import React from 'react';
import {compose} from 'react-apollo';

import {Card} from 'ui-kit';

import {PayoutsTable} from './components';
import * as styles from './PayoutsList.module.css';

function PayoutsList({payouts}) {
  return (
    <div className={styles.Container}>
      <Card>
        <h3 className={styles.Heading}>Payouts</h3>
        {payouts.length === 0 ? (
          <p>Your account does not have any payouts yet.</p>
        ) : (
          <PayoutsTable payouts={payouts} />
        )}
      </Card>
    </div>
  );
}

export default compose()(PayoutsList);
